import { Component } from '@mycolorway/tao';
import Dialog from 'next/javascripts/components/dialog';
import editorFormMixin from 'next/javascripts/mixins/editor-form-mixin';

Component('tr-dialog-repository', {
  extends: [Dialog],

  mixins: [editorFormMixin],

  ready() {
    this.listenTo(this, 'tao:opened', () => {
      const editor = this.querySelector('tr-editor[lazyload]');
      if (editor) editor.initEditor();
    });
  },
});
